import React, { Fragment, forwardRef, useContext } from 'react'
import {
  StyledSegmentedList,
  StyledSegmentedSeparator
} from '../styled-components'
import { SegmentedContext } from './segmented-context'

const SegmentedList = forwardRef((props, forwardedRef) => {
  const { children, ...listProps } = props
  const context = useContext(SegmentedContext)

  const triggers = React.Children.toArray(children)

  return (
    <StyledSegmentedList role="segmented" {...listProps} ref={forwardedRef}>
      {triggers.map((trigger, index) => {
        const notActive = trigger.props.value !== context.value
        const notLast = index < triggers.length - 1

        const nextTrigger =
          notLast && triggers[index + 1].props.value === context.value

        if (notActive && !nextTrigger && notLast) {
          return (
            <Fragment key={index}>
              {React.cloneElement(trigger, { key: index })}
              <StyledSegmentedSeparator />
            </Fragment>
          )
        }

        return React.cloneElement(trigger, { key: index })
      })}
    </StyledSegmentedList>
  )
})

SegmentedList.displayName = 'SegmentedList'
export default SegmentedList
